import type { Ref } from 'react'
import { ShortcutHintProps } from './ShortcutHint.types'
import './ShortcutHint.scss'

export function ShortcutHint({
  children,
  variant = 'default',
  className,
  ref,
  ...rest
}: ShortcutHintProps & { ref?: Ref<HTMLSpanElement> }) {
  const variantClass = variant === 'default' ? '' : ` shortcut-hint--${variant}`
  return (
    <span
      {...rest}
      ref={ref}
      className={`shortcut-hint${variantClass}${className ? ` ${className}` : ''}`}
    >
      {children}
    </span>
  )
}
